<template>
	<div class="cart-page submit-page" v-loading="isLoading">
		<div class="submit-title">
			收货地址
		</div>
		<el-card class="box-card address-box" shadow="never">
			<div class="address" v-if="selectAddress != '' && !showMore">
				<div class="select-box">
					<ul class="infor-list select select-add">
						<li>{{selectAddress.consignee}}</li>
						<li class="phone">{{selectAddress.phone}}</li>
						<li>{{selectAddress.province}}{{selectAddress.city}}{{selectAddress.district}}{{selectAddress.address}}
						</li>
					</ul>
				</div>
				<el-button class="add-btn" size="mini" @click="handleAddAddress">新建地址<i
						class="el-icon-plus el-icon--right"></i></el-button>
			</div>
			<div class="address" v-if="!showMore && selectAddress == ''">
				<div>
					<ul class="infor-list" v-for="(item,index) in addressList" :key="index"
						:class="{select:index == addressIndex}" @click="handleSelect(index)" v-if="index ==0">
						<li>{{item.consignee}}</li>
						<li class="phone">{{item.phone}}</li>
						<li>{{item.province}}{{item.city}}{{item.district}}{{item.address}}</li>
					</ul>
				</div>
				<el-button class="add-btn" size="mini" @click="handleAddAddress">新建地址<i
						class="el-icon-plus el-icon--right"></i>
				</el-button>

			</div>
			<div class="address" v-if="showMore" @click="showMore = false">
				<div>
					<ul class="infor-list" v-for="(item,index) in addressList" :key="index"
						:class="{select:index == addressIndex}" @click="handleSelect(index)">
						<li>{{item.consignee}}</li>
						<li class="phone">{{item.phone}}</li>
						<li>{{item.province}}{{item.city}}{{item.district}}{{item.address}}</li>
					</ul>
				</div>
				<el-button class="add-btn" size="mini" @click.stop="handleAddAddress">新建地址<i
						class="el-icon-plus el-icon--right"></i>
				</el-button>
			</div>
			<template v-if="addressList.length > 1">
				<div class="more" v-if="!showMore" @click="handleMore">更多地址<i class="el-icon-caret-bottom"></i></div>
				<div class="more" v-if="showMore" @click="handleMore">收起地址<i class="el-icon-caret-top"></i></div>
			</template>

		</el-card>
		<div class="submit-title">
			商品信息
		</div>
		<div class="table-header">
			<div class="tab2">全部商品</div>
			<div class="tab3">单价</div>
			<div class="tab4">数量</div>
			<div class="tab5">小计</div>
		</div>
		<div class="table-box">
			<div class="tr-box" v-for="(item, index) in cartItems" :key="item.id">
				<div class="gift-info-submit" v-if="item.gift && item.gift.threshold">
					<div class="tag">赠</div>
					<div class="tip">购买{{ item.gift.threshold }}件可得赠品</div>
				</div>
				<div class="gift-info-submit" v-if="getFilterActivitysList(item,3).length > 0">
					<div class="tag">减</div>
					<div class="tip">
						满{{
				  parseFloat(
				    getFilterActivitysList(item,3)[0].minPoint
				  )
				}}减{{
				  parseFloat(
				    getFilterActivitysList(item,3)[0].amount
				  )
				}}
					</div>
				</div>
				<div class="gift-info-submit" v-if="getFilterActivitysList(item,4).length > 0">
					<div class="tag">特</div>
					<div class="tip">
						特价{{
				  parseFloat(
				    getFilterActivitysList(item,4)[0].buyPrice
				  )
				}}元
					</div>
				</div>
				<div class="gift-info-submit" v-if="getFilterActivitysList(item,5).length > 0">
					<div class="tag">折</div>
					<div class="tip">
						限时{{
				  parseFloat(
				    getFilterActivitysList(item,5)[0].discount
				  ) * 10
				}}折
					</div>
				</div>
				<div class="gift-info-submit" v-if="getFilterActivitysList(item,6).length > 0">
					<div class="tag">抢</div>
					<div class="tip">
						限时抢购</div>
				</div>
				<div class="gift-info-submit" v-if="getFilterActivitysList(item,7).length > 0">
					<div class="tag">限</div>
					<div class="tip">
						限购{{
				  getFilterActivitysList(item,7)[0].perLimit
				}}件
					</div>
				</div>
				<div class="tr-content">
					<div class="tab2">
						<div class="img-box"><img :src="item.pic" /></div>
						<div class="tab2-info">
							<div class="name">{{ item.productName }}</div>
							<div class="msg">
								<div class="label">规</div>
								<div class="val">{{item.speci}}</div>
							</div>
							<div class="msg">
								<div class="label">厂</div>
								<div class="val">{{item.manufacturers}}</div>
							</div>
						</div>

					</div>
					<div class="tab3">
						<div class="price">￥{{ formatNum(item.price) }}</div>
					</div>
					<div class="tab4">
						{{item.quantity}}
					</div>
					<div class="tab5">
						<div class="price">
							￥{{ item.quantity && item.quantity != '0' && item.quantity > 0 ? formatNum(parseFloat(item.price) * item.quantity) : formatNum(item.price) }}
						</div>
					</div>
				</div>
				<div class="gift-box" v-if="item.gift && item.gift.threshold && item.quantity >= item.gift.threshold">
					<div class="tag">【赠】</div>
					<div class="img-box"><img :src="item.gift.pic" /></div>
					<div class="product-msg">
						<div class="name">
							<div class="left">{{ item.gift.giftProductName }}</div>
							<div class="right">×{{ parseInt(item.quantity/item.gift.threshold)*item.gift.count }}</div>
						</div>
						<div class="msg">
							<div class="label">规</div>
							<div class="val">{{ item.gift.speci }}</div>
						</div>
						<div class="msg">
							<div class="label">厂</div>
							<div class="val">{{item.gift.manufacturers}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="statistics-msg-box" :style="{'display': payInfo!='' ? '' : 'block'}">
			<div class="choose-coupon">
				<div class="title" @click="showCoupon = !showCoupon">
					选择使用优惠券
					<i class="el-icon-caret-bottom" v-if="!showCoupon"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<ul class="list" v-if="showCoupon">
					<template v-if="ableCouponList.length > 0">
						<li v-for="(item,index) in ableCouponList" :key="index" :class="{select:index == selectIndex}"
							@click="handleUseAble(item,index)">
							<div class="img-box">
								<!-- <img src="../../assets/images/coupon-bg.png" /> -->
								<div class="inner">
									<div class="amount">￥ <span>
											{{item.amount.split('.')[0] }}
										</span>
										<span style="font-size: 15px;">.{{item.amount.split('.')[1]}}</span>
									</div>
									<div class="type">
										{{item.type ==1 ?'单品券':'全场券'}}
									</div>

								</div>
							</div>
							<div class="coupon-info">
								<div class="name">{{item.name}}</div>
								<div class="limit">订单满{{parseFloat(item.minPoint)}}元可用</div>
								<div class="time" v-if="item.enableStartTime && item.enableEndTime">
									{{item.enableStartTime.split(' ')[0]}}~{{item.enableEndTime.split(' ')[0]}}
								</div>
							</div>
						</li>
					</template>
					<li class="no-data" v-else>暂无可用优惠券</li>
				</ul>
				<ul class="list" v-else-if="selectCoupon">
					<li class="select" @click="handleUseAble(selectCoupon, selectIndex, true)">
						<div class="img-box">
							<!-- <img src="../../assets/images/coupon-bg.png" /> -->
							<div class="inner">
								<div class="amount">￥ <span>
										{{selectCoupon.amount.split('.')[0] }}
									</span> <span style="font-size: 15px;">.{{selectCoupon.amount.split('.')[1]}}</span>
								</div>
								<div class="type">
									{{selectCoupon.type ==1 ?'单品券':'全场券'}}
								</div>

							</div>
						</div>
						<div class="coupon-info">
							<div class="name">{{selectCoupon.name}}</div>
							<div class="limit">订单满{{parseFloat(selectCoupon.minPoint)}}元可用</div>
							<div class="time" v-if="selectCoupon.enableStartTime && selectCoupon.enableEndTime">
								{{selectCoupon.enableStartTime.split(' ')[0]}}~{{selectCoupon.enableEndTime.split(' ')[0]}}
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="choose-coupon">
				<div class="title">
					备注：<input type="text" v-model="remark" placeholder="请输入您要备注的内容">
				</div>

			</div>
			<div class="right-box" v-if="payInfo!=''">
				<div class="box1">
					<div>
						<div class="label">商品合计：</div>
						<div class="price">￥{{payInfo.totalAmount}}</div>
					</div>
					<div>
						<div class="label">邮费：</div>
						<div class="price">￥{{payInfo.sendAmount}}</div>
					</div>
					<div>
						<div class="label">活动优惠：</div>
						<div class="price"><template
								v-if="payInfo.discountAmount != 0">-￥</template>{{payInfo.discountAmount}}
						</div>
					</div>
					<div>
						<div class="label">优惠券：</div>
						<div class="price"><template v-if="payInfo.couponAmount != 0">-￥</template>
							{{parseFloat(payInfo.couponAmount)}}
						</div>
					</div>
				</div>
				<div class="total-box">
					<div class="box2 total-box2">
						<div>
							<div class="label">应付总额：</div>
							<div class="price">￥{{payInfo.userAmount}}</div>
						</div>
					</div>
					<div class="end-address" v-if="selectAddress!=''">
						寄送至：{{selectAddress.province}}{{selectAddress.city}}{{selectAddress.district}}{{selectAddress.address}}
						<span>
							收货人：{{selectAddress.consignee}}
						</span>
					</div>
				</div>
				<el-button type="primary" @click="handleSubmit" :loading="isBtnLoading">提交订单</el-button>
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="400px" :before-close="handleLimit">
			<div class="warning-box">
				<div class="warning-list">
					<div class="li">
						当前{{payInfo.payType == 'PAYMENT' ? '余额' :'授信额度'}}不足
					</div>
					<div class="li">
						当前{{payInfo.payType == 'PAYMENT' ? '余额' :'授信额度'}}： ￥{{payInfo.balance}}
					</div>
					<div class="li">
						支付金额： ￥{{parseFloat(payInfo.userAmount)}}
					</div>
					<div class="li">
						请再充值： ￥{{Math.abs(payInfo.balance - parseFloat(payInfo.userAmount)).toFixed(2)}} 订单72小时有效
					</div>
				</div>
				<div class="btn" @click="handleLimit">
					确认
				</div>
			</div>
		</el-dialog>
		<successPop :sucessPopShow="dialogVisibleSucess" :userAmount="parseFloat(payInfo.userAmount)"
			@handleLimit="handleLimit" @handleSucessShow="handleLimit"></successPop>
		<add-address-component v-if="showDialog" @saveDialog="saveDialog" @closeDialog="showDialog = false"
			:loading="addLoading" />
	</div>
</template>

<script>
	import {
		getAllAddress,
		addEnterpriseAddress
	} from '@/api/address'
	import {
		availableCoupon,
		unAvailableCoupon
	} from '@/api/home'
	import {
		doPayOrder,
		getOrder
	} from '@/api/order.js';
	import {
		getCartList
	} from '@/api/goods.js';
	import {
		formatNum
	} from '@/utils';
	import addAddressComponent from '@/components/addAddressComponent'
	import successPop from '@/components/successPop'

	export default {
		components: {
			addAddressComponent,
			successPop
		},
		data() {
			return {
				isLoading: false,
				isBtnLoading: false,
				cartItems: [],
				selectCoupon: '',
				payInfo: '', //支付的金额明细
				showMore: false,
				addressList: [],
				selectAddress: '',
				addressIndex: -1,
				dialogVisible: false,
				dialogVisibleSucess: false,
				remark: '',
				showDialog: false,
				addLoading: false,
				ableCouponList: [],
				unableCouponList: [],
				selectIndex: -1,
				showCoupon: false
			};
		},
		beforeMount() {
			this.getAllAddress()
		},
		created() {
			window.scrollTo(0, 0);
		},
		destroyed() {
			window.sessionStorage.removeItem('orderMsgSession');
		},
		methods: {
			getFilterActivitysList(item, type) {
				return item?.activityList?.length > 0 ? item.activityList.filter(e => e.type == type) : []
			},
			handleUseAble(item, index, isShow) {
				if (this.selectIndex != index) {
					this.selectIndex = index
					this.selectCoupon = item
				} else {
					this.selectIndex = -1
					this.selectCoupon = ''
				}

				if (!isShow) {
					this.showCoupon = !this.showCoupon
				}

				this.getOrderInfor(true)

			},
			handleAddAddress() {
				this.showDialog = true
			},
			saveDialog(e) {
				this.addLoading = true
				addEnterpriseAddress(e).then(res => {
					this.addLoading = false
					this.showDialog = false
					this.getAllAddress(true)
				})
			},
			getAllAddress(isSelect) {
				getAllAddress().then(res => {
					if (res && res.code == 0 && res.data) {
						this.addressList = res.data
						if (isSelect) {
							this.addressIndex = 0
							this.selectAddress = this.addressList[0]
						} else if (this.addressList.length > 0) {
							if (this.addressList.filter(e => e.isDefault).length > 0) {
								this.selectAddress = this.addressList.filter(e => e.isDefault)[0]
							}
						}
					}

					// 单品购买
					if (window.sessionStorage.getItem('orderMsgSession')) {
						let orderMsg = JSON.parse(window.sessionStorage.getItem('orderMsgSession'));
						this.cartItems = [{
							activityList: orderMsg.activities,
							pic: orderMsg.pic,
							price: orderMsg.buyPrice,
							productName: orderMsg.name,
							productTypeCode: orderMsg.productTypeCode,
							quantity: orderMsg.quantity,
							speci: orderMsg.speci,
							manufacturers: orderMsg.manufacturers
						}];
						this.getOrderInfor(true);
					} else {
						this.getCartList();
					}
				})
			},
			handleMore() {
				this.showMore = !this.showMore
			},
			handleSelect(index) {
				this.addressIndex = index
				this.selectAddress = this.addressList[index]
				this.getOrderInfor(true)
			},
			formatNum(num) {
				if (num) {
					return formatNum(num);
				}
				return '';
			},
			handleSubmit() {
				if (this.addressList.length == 0) {
					this.$message({
						message: '请填写收货地址',
						type: 'warning',
						duration: 1500
					});
					setTimeout(() => {
						this.showDialog = true
					}, 1600)
					return
				}
				if (this.selectAddress == '') {
					this.$message({
						message: '请选择收货地址',
						type: 'warning'
					});
					return
				}
				this.getOrderInfor(false)
			},
			getCoupon() {
				this.isLoading = true
				let cartItems = this.payInfo.details.map(e => {
					return {
						productId: e.productTypeCode,
						quantity: e.quantity,
						totalPrice: e.settlementPrce,
					}
				})
				Promise.all([
					availableCoupon(cartItems),
					unAvailableCoupon(cartItems)
				]).then(res => {
					this.isLoading = false
					if (res && res[0] && res[0].code == 0 && res[0].data) {
						this.ableCouponList = res[0].data
					}
					if (res && res[1] && res[1].code == 0 && res[1].data) {
						this.unableCouponList = res[1].data
					}
				})
			},
			/**
			 * 2023-02-07 董浩
			 * 获取购物车列表
			 * */
			getCartList() {
				getCartList().then(res => {
					if (res && res.code == 0 && res.data && res.data.items) {
						this.cartItems = res.data.items.filter(e => {
							return e.isCheck == true
						})
						this.getOrderInfor(true)
					}
				});
			},
			getOrderInfor(pre) {
				// pre true是只计算不下单，false是下单
				// isCheck true 是只筛选勾选的，false，是全部
				let cartItems = this.cartItems.map(e => {
					return {
						id: e.id,
						productType: e.productTypeCode,
						quantity: e.quantity,
					}
				})
				let params = {
					memberAddressId: this.selectAddress == '' ? '' : this.selectAddress.id,
					invoiceId: '', //发票
					isCheck: true,
					pre: pre,
					remark: this.remark,
					discountId: this.selectCoupon == '' ? '' : this.selectCoupon.receiveId,
					cartItems: cartItems
				}
				if (!pre) {
					// 下单
					this.isBtnLoading = true
				} else {
					// 计算金额
					this.isLoading = true
				}
				getOrder(params).then(res => {
					this.isLoading = false
					if (res && res.code == 0 && res.data) {
						this.payInfo = res.data
						if (pre) this.getCoupon() //获取优惠券列表

						if (!pre) {
							doPayOrder({
								orderId: res.data.id
							}).then(res => {
								this.isBtnLoading = false
								if (res && res.code == 0) {
									this.dialogVisibleSucess = true
								} else {
									this.dialogVisible = true
								}
							})
						}
					} else {
						if (!pre) {
							// 下单
							this.isBtnLoading = false
						}
						this.$message.error(res.msg);
					}
				})

			},
			handleLimit() {
				this.$router.replace('/orderDetails?orderId=' + this.payInfo.id);
			},
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.submit-page {
		padding: 10px 0;

		.address-box {
			border: none;
			border-radius: 10px;
			margin-bottom: 40px;

			.add-btn {
				background: #F8F8F8;
				border: 1px solid #C0C4CC;
				border-radius: 5px;
				color: #262728;
			}

			.address {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				width: 100%;

				&>div {
					width: calc(100% - 130px);


					.infor-list {
						display: flex;
						font-size: 14px;
						font-weight: 400;
						color: #606366;
						margin-bottom: 20px;
						width: 100%;
						border-radius: 5px;
						border: 1px solid #EDEFF2;
						cursor: pointer;

						li {
							margin-right: 30px;
							padding: 6px 12px;
							width: 100px;
						}

						li:first-child {
							width: 270px;
						}

						li:last-child {
							flex: 1;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}


					}

					.select-add {
						margin-bottom: 0;

					}

					.select {
						border: 1px solid #FECE36;
						background: #FFFAEB;
						color: #262728;
					}
				}

				.select-box {
					display: flex;
					align-items: flex-start;
					justify-content: space-between;
				}

				.infor-list:last-child {
					margin-bottom: 0;
				}
			}

			.more {
				font-size: 14px;
				font-weight: 400;
				color: #606366;
				margin-top: 20px;
				cursor: pointer;

				.el-icon-caret-bottom,
				.el-icon-caret-top {
					margin-left: 8px;
				}

			}

		}

		.submit-title {
			font-size: 24px;
			font-weight: 400;
			color: #262728;
			margin-bottom: 15px;
		}

		.table-header,
		.tr-content,
		.statistics-msg-box {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			background-color: #FFFFFF;
			border-radius: 8px;
			color: $fontColor;

			.tab1 {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				padding: 0 20px;
				width: 150px;
				font-size: 14px;

				.el-checkbox {
					.el-checkbox__inner {
						width: 20px;
						height: 20px;
						border: 1px solid #C0C4CC;
						border-radius: 5px;
					}

					.is-checked {
						.el-checkbox__inner {
							border-color: $main;
						}
					}

					.el-checkbox__inner::after {
						top: 4px;
						left: 7px;
						border: 2px solid $fontColor;
						border-left: 0;
						border-top: 0;
					}

					.el-checkbox__label {
						padding-left: 6px;
						font-size: 14px;
						color: $fontColor;
					}
				}


			}

			.tab2 {
				padding: 0 20px;
				width: 650px;
				font-size: 14px;
				display: flex;

				.img-box {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100px;
					height: 100px;
					margin-right: 20px;
					background: #FFFFFF;
					border: 1px solid #EDEFF2;
					border-radius: 10px;
					overflow: hidden;

					img {
						width: 100%;
					}
				}

				.tab2-info {
					width: calc(100% - 120px);

					.name {
						margin-top: 10px;
						line-height: 1.4;
						font-size: 16px;
						color: $fontColor;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.msg {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						margin-top: 10px;

						.label {
							flex-shrink: 0;
							display: flex;
							justify-content: center;
							align-items: center;
							width: 20px;
							height: 20px;
							background: #FFFFFF;
							border: 1px solid #C0C4CC;
							border-radius: 5px;
							font-size: 13px;
							font-weight: 400;
							color: #909399;
						}

						.val {
							margin-left: 4px;
							line-height: 1.4;
							font-size: 14px;
							font-weight: 400;
							color: #909399;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}
				}

			}

			.tab3 {
				padding-right: 20px;
				width: 180px;
				text-align: center;

				.price {
					font-size: 16px;
				}
			}

			.tab4 {
				padding-right: 20px;
				width: 180px;
				font-size: 16px;
				text-align: center;

				.opt-box {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					height: 28px;
					width: 112px;
					border: 1px solid #C0C4CC;
					border-radius: 5px;
					overflow: hidden;

					.opt-icon {
						flex-shrink: 0;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 28px;
						height: 100%;
						background: #F8F8F8;
						cursor: pointer;

						.iconfont {
							font-size: 13px;
							color: $fontColor;
						}
					}

					.el-input {
						.el-input__inner {
							padding: 0 9px;
							width: 56px;
							height: 28px;
							border-top: none;
							border-bottom: none;
							border-left: 1px solid #C0C4CC;
							border-right: 1px solid #C0C4CC;
							border-radius: 0;
							text-align: center;
							font-size: 16px;
						}
					}
				}
			}

			.tab5 {
				padding-right: 20px;
				width: 180px;
				text-align: center;

				.price {
					font-size: 16px;
				}
			}

		}

		.table-header {
			padding: 20px 0;
			font-size: 14px !important;
		}

		.table-box {
			margin-top: 10px;
			background-color: #FFFFFF;
			border-radius: 8px;

			.tr-box:first-child {
				border-top: none;
			}

			.tr-box {
				padding: 20px 0;
				border-top: 1px dashed #EDEFF2;

				.gift-info-submit {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					margin-bottom: 10px;
					padding-left: 20px;

					.tag {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 18px;
						height: 18px;
						background: #f65b13;
						border-radius: 4px;
						font-size: 12px;
						font-weight: bold;
						color: #ffffff;
					}

					.tip {
						margin-left: 6px;
						font-size: 15px;
						font-weight: bold;
						color: #262728;
					}
				}

				.tr-content {
					align-items: flex-start;

					.tab3 {
						font-size: 16px;
					}
				}

				.gift-box {
					display: flex;
					justify-content: flex-start;
					align-items: flex-start;
					margin: 10px 20px 0 !important;
					padding: 10px 14px 12px 7px;
					width: 610px;
					height: 103px;
					background: #F8F8F8;
					border-radius: 8px;

					.tag {
						flex-shrink: 0;
						padding-top: 20px;
						font-size: 14px;
						font-weight: 400;
						color: #F07463;
					}

					.img-box {
						flex-shrink: 0;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 60px;
						height: 60px;
						background: #FFFFFF;
						border: 1px solid #EDEFF2;
						border-radius: 8px;
						overflow: hidden;

						img {
							width: 100%;
						}
					}

					.product-msg {
						flex: 1;
						margin-left: 20px;

						.name {
							display: flex;
							justify-content: space-between;
							align-items: center;
							margin-bottom: 2px;
							line-height: 1.4;

							.left {
								flex: 1;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								font-size: 16px;
								color: $fontColor;
							}

							.right {
								flex-shrink: 0;
								margin-left: 20px;
								font-size: 16px;
								color: #909399;
							}
						}

						.msg {
							display: flex;
							justify-content: flex-start;
							align-items: center;
							margin-top: 10px;

							.label {
								flex-shrink: 0;
								display: flex;
								justify-content: center;
								align-items: center;
								width: 20px;
								height: 20px;
								border: 1px solid #C0C4CC;
								border-radius: 5px;
								font-size: 13px;
								font-weight: 400;
								color: #909399;
							}

							.val {
								margin-left: 4px;
								line-height: 1.4;
								font-size: 14px;
								font-weight: 400;
								color: #909399;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}
					}
				}
			}
		}

		.statistics-msg-box {
			margin-top: 10px;
			display: block !important;

			.choose-coupon {
				border-bottom: 1px solid #EDEFF2;

				&>div {
					font-size: 16px;
					font-weight: 400;
					color: #262728;
					padding: 30px 10px 30px 45px;
					display: flex;
					align-items: center;
					cursor: pointer;


					.el-icon-caret-bottom,
					.el-icon-caret-top {
						color: #909399;
						margin-left: 5px;
					}

					input {
						border: none;
						margin-left: 90px;
						font-size: 16px;
						flex: 1;
					}
				}

				.list {
					display: flex;
					flex-wrap: wrap;
					width: 100%;
					box-sizing: border-box;
					padding: 0 45px 0;

					li {
						width: calc(25% - 10px);
						height: 98px;
						background: #fff;
						border: 1px solid #EEEEEE;
						border-radius: 15px;
						display: flex;
						padding: 16px 10px 16px 5px;
						margin-right: 10px;
						margin-bottom: 10px;
						cursor: pointer;

						.img-box {
							width: 90px;
							height: 66px;
							flex-shrink: 0;
							position: relative;

							.inner {
								display: flex;
								flex-direction: column;
								position: absolute;
								width: 100%;
								height: 100%;
								align-items: center;
								justify-content: space-around;
								box-sizing: border-box;
								top: 0;
								padding-bottom: 5px;

								.amount {
									color: #EE3C20;
									font-size: 14px;
									font-weight: bold;
									display: flex;
									align-items: baseline;

									span {
										font-size: 22px;
									}
								}

								.type {
									font-size: 13px;
									font-weight: 500;
									color: #EE3C20;
								}
							}

						}

						.coupon-info {
							margin-left: 12px;
							width: calc(100% - 93px);

							.name {
								font-size: 16px;
								font-weight: 400;
								color: #0D1012;
								width: 100%;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;

							}

							.limit {
								font-size: 13px;
								font-weight: 400;
								color: #606366;
							}

							.time {
								font-size: 12px;
								font-weight: 400;
								color: #606366;
							}
						}
					}

					li:nth-child(4n) {
						margin-right: 0;
					}

					.select {
						border: 2px solid #FDDCDC;
						background: #FFF6F9;
						position: relative;
					}

					.select::after {
						position: absolute;
						width: 16px;
						height: 14px;
						background: #EE3C20;
						color: #fff;
						border-radius: 5px 0 5px 0;
						content: '✔';
						right: 0;
						bottom: -2px;
						text-align: right;
						line-height: 14px;
						font-size: 10px;
						box-sizing: border-box;
						padding-right: 3px;
					}

					.no-data {
						align-items: center;
						justify-content: center;
						padding-right: 20px;
						font-size: 18px;
					}
				}
			}

			.tab2 {
				cursor: pointer;
			}

			.right-box {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: flex-end !important;
				flex-direction: column;
				box-sizing: border-box;
				padding: 20px 10px 30px;

				.box1,
				.box2 {
					width: 300px !important;
					color: $fontColor;
					text-align: right;
					box-sizing: border-box;
					padding-right: 20px;

					&>div {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						width: 100%;
						margin-bottom: 20px;

						.label {
							width: 70px;
							font-size: 14px;
						}

						.price {
							margin-left: 120px;
							font-size: 15px;
							flex: 1;
						}
					}
				}


				.box2 {
					padding-right: 0;

					.price {
						font-size: 16px;
						font-weight: bold;
						color: #EE3C20;
					}
				}

				.total-box2 {
					width: 300px !important;
					padding-left: 20px !important;

					.price {
						margin-left: 100px !important;
					}
				}

				.total-box {
					background: #F8F8F8;
					border-radius: 8px;
					width: 100%;
					box-sizing: border-box;
					padding: 20px;
					margin-bottom: 20px;
					display: flex;
					justify-content: flex-end;
					flex-direction: column;
					align-items: flex-end;

					.end-address {
						font-size: 14px;
						font-weight: 400;
						color: #262728;

						span {
							margin-left: 60px;
						}
					}
				}

				.el-button {
					width: 118px;
					height: 48px;
					background: $main;
					border-radius: 8px;
					font-family: Alibaba PuHuiTi;
					font-size: 18px;
					font-weight: bold;
					color: $fontColor;
					margin-right: 20px;
				}
			}
		}
	}

	.warning-box {
		width: 307px;
		background: #FFFFFF;
		border-radius: 15px;
		margin: 0 auto;
		box-sizing: border-box;
		padding: 20px 29px;
		padding-top: 0;
		// margin-top: -130px;

		.title {
			margin: 0 auto;
			text-align: center;
			font-size: 17px;
			font-weight: bold;
			color: #000000;
		}

		.btn {
			width: 100%;
			background: #FFCC00;
			line-height: 40px;
			text-align: center;
			color: #262728;
			font-size: 15px;
			font-weight: bold;
			border-radius: 23px;
		}

		.warning-list {
			margin: 0 0 30px;
			width: 100%;
			font-size: 13px;
			font-weight: 500;
			color: #606366;

			.li {
				margin-bottom: 5px;
			}
		}
	}
</style>